export default __webpack_public_path__ + "locales/vi/InfoPanel.json?hash=92d1d7e13a2a6756bf9ded81e9c4e6da";